import { useI18n } from '../i18n/LanguageContext';
import { SelectMenu } from './SelectMenu';

type TextFieldProps = {
  label: string;
  value: string;
  onChange: (v: string) => void;
  placeholder?: string;
  type?: string;
  autoComplete?: string;
};

export function TextField({ label, ...props }: TextFieldProps) {
  const { tr } = useI18n();
  return (
    <label className="text-sm space-y-1">
      <span className="text-slate-500">{tr(label)}</span>
      <input
        className="w-full border border-slate-200 rounded-lg px-3 py-2"
        type={props.type || 'text'}
        value={props.value}
        placeholder={props.placeholder ? tr(props.placeholder) : undefined}
        autoComplete={props.autoComplete}
        onChange={(e) => props.onChange(e.target.value)}
      />
    </label>
  );
}

type SelectFieldProps = {
  label: string;
  options: string[];
  value: string;
  onChange: (v: string) => void;
};

export function SelectField({ label, options, value, onChange }: SelectFieldProps) {
  const { tr } = useI18n();
  return (
    <label className="text-sm space-y-1">
      <span className="text-slate-500">{tr(label)}</span>
      <SelectMenu
        value={value}
        onChange={onChange}
        buttonAriaLabel={tr(label)}
        triggerClassName="w-full rounded-lg border border-slate-200 px-3 py-2 bg-white"
        options={options.map((opt) => ({ value: opt, label: tr(opt) }))}
      />
    </label>
  );
}
